export default "__VITE_ASSET__BKEUKyEo__"